import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Typography } from '@mui/material';
import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function RowPages({ rowsPerPage, onRowsPerPageChange, All }) {

  const handleChange = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <>
      <Typography variant="subtitle2">
        Rows Per Page
      </Typography>
      <FormControl size="small">
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={rowsPerPage}
          label="Rows"
          onChange={handleChange}
          sx={{
            '& legend': { display: 'none' },
            '& .MuiInputLabel-shrink': { opacity: 0, transition: "all 0.2s ease-in" },
            width: "80px",
            minWidth: "50px",
            mx: 2,
            mt: 0.5,
          }}
        >
          <MenuItem value={30}>30</MenuItem>
          <MenuItem value={60}>60</MenuItem>
          <MenuItem value={90}>90</MenuItem>
          <MenuItem value={120}>120</MenuItem>
          <MenuItem value={150}>150</MenuItem>
          <MenuItem value={All}>All</MenuItem>
        </Select>
      </FormControl>
    </>
  );
}